import {
  TooltipTrigger as RACTooltipTrigger,
  type TooltipTriggerComponentProps as RACTooltipTriggerComponentProps,
} from 'react-aria-components/Tooltip';

export const TooltipTrigger = ({
  children,
  delay = 500,
  ...props
}: RACTooltipTriggerComponentProps) => {
  return (
    <RACTooltipTrigger delay={delay} {...props}>
      {children}
    </RACTooltipTrigger>
  );
};
